import React, { useEffect, useState } from 'react';
import { Pagination, Table } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import { StaffStaffSearchContainerStaffUsersSearchFieldsFragment } from '../../../../generated';
import { DATE_TIME_FORMAT } from '../../../../constants';
import { FormatDate } from '../../../../constants';

interface PaginationComponentProps {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number, size?: number) => void;
}

const PaginationComponent: React.FC<PaginationComponentProps> = (props) => {
  return (
    <Pagination
      current={props.current}
      pageSize={props.pageSize}
      total={props.total}
      onChange={props.onChange}
      onShowSizeChange={props.onChange}
      className="rounded-[10px] p-[15px] border border-[#f0f0f0] my-3"
    />
  );
};

const columns = [
  {
    title: 'Name',
    dataIndex: 'displayName',
    key: 'displayName',
    render: (text: any, record: any) => (
      <Link to={`${record.id}/staff-details/view`}>
        {text}
      </Link>
    ),
    type: 'link'
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (text: string) => {
      return FormatDate(text, DATE_TIME_FORMAT);
    },
    type: 'date'
  },
  {
    title: 'Blocked',
    dataIndex: 'accessBlocked',
    key: 'accessBlocked',
    type: 'string',
    render: (text: boolean) => {
      if (text) {
        return 'Yes';
      } else {
        return 'No';
      }
    }
  },
  {
    title: 'Role',
    dataIndex: ['role', 'roleName'],
    key: 'role',
    type: 'string'
  }
];

interface StaffSearchTableProps {
  data: StaffStaffSearchContainerStaffUsersSearchFieldsFragment[];
  resultCount: number;
}

export const StaffSearchTable: React.FC<StaffSearchTableProps> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const handlePaginationChange = (page: number, size?: number) => {
    const newSize = size || pageSize;
    setCurrentPage(page);
    setPageSize(newSize);
    searchParams.set('page', page.toString());
    searchParams.set('pageSize', newSize.toString());
    setSearchParams(searchParams);
  };

  useEffect(() => {
    const page = parseInt(searchParams.get('page') || '1', 10);
    const size = parseInt(searchParams.get('pageSize') || '10', 10);

    setCurrentPage(page);
    setPageSize(size);
  }, [searchParams]);

  return (
    <div className="flex flex-col w-full pt-[2px]">
      <PaginationComponent current={currentPage} pageSize={pageSize} total={props.resultCount} onChange={handlePaginationChange} />
      <Table className="w-full border border-[#f0f0f0] rounded-[10px] p-[15px] max-w-full border-solid" scroll={{x: "max-content"}} columns={columns} dataSource={props.data} rowKey="id" pagination={false} rowHoverable={false} />
      <PaginationComponent current={currentPage} pageSize={pageSize} total={props.resultCount} onChange={handlePaginationChange} />
    </div>
  );
};
